import { render, staticRenderFns } from "./faqs.vue?vue&type=template&id=54b30b54&"
import script from "./faqs.vue?vue&type=script&lang=js&"
export * from "./faqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports